import React, { useEffect, useState } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
    createFeature,
    editFeature,
    fetchFeatures,
    getFeatures,
} from '../../app/reducers/Features/featureSlice';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import SecondaryButton from '../../components/infrastructure/Buttons/SecondaryButton';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';
import { ClipLoader } from 'react-spinners';
import ToggleButton from '../../components/ToggleButton/ToggleButton';

const Features = () => {
    const [individualLoading, setIndividualLoading] = useState({})
    const dispatch = useDispatch();
    const { features, loading, editDataLoading } = useSelector(getFeatures);
    useEffect(() => {
        dispatch(fetchFeatures({sort : { createdAt : 1}}));
    }, []);
    const cols = [
        { Header: 'System Id', accessor: '_id' },
        { Header: 'Name', accessor: 'name' },
        { Header: 'Status', accessor: 'status' },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                // if (loading || editDataLoading) {
                //     return <ClipLoader />;
                // }
                const isLoading = individualLoading[row?.original._id]
                return (
                    <div className="flex">
                        {isLoading ? (
                            <ClipLoader size={20}/>
                        ) : (
                            <ToggleButton
                                toggled={row?.original?.status === 'active'}
                                onClick={async () => {
                                    try {                                        
                                        setIndividualLoading((prev)=>({...prev, [row?.original._id] : true}))
                                        const editStatus =
                                            row?.original?.status === 'active'
                                                ? 'inactive'
                                                : 'active';
    
                                        await dispatch(
                                            editFeature({
                                                _id: row.original._id,
                                                status: editStatus,
                                            })
                                        );
    
                                        dispatch(
                                            fetchFeatures({
                                                sort: { createdAt: 1 },
                                            })
                                        );
                                    } catch (error) {
                                        console.log('Failed to edit feature')
                                    } finally {
                                        setIndividualLoading((prev)=>({...prev, [row?.original._id] : false}))
                                    }
                                }}
                            />
                        )}
                        {/* {row?.original?.status === 'active' ? (
                            <div>
                                <DangerButton
                                    onClick={async () => {
                                        await dispatch(
                                            editFeature({
                                                _id: row.original._id,
                                                status: 'inactive',
                                            })
                                        );
                                        dispatch(fetchFeatures({sort : { createdAt : 1}}));
                                    }}
                                >
                                    Deactivate
                                </DangerButton>
                            </div>
                        ) : (
                            <div>
                                <SecondaryButton
                                    onClick={async () => {
                                        await dispatch(
                                            editFeature({
                                                _id: row.original._id,
                                                status: 'active',
                                            })
                                        );
                                        dispatch(fetchFeatures({sort : { createdAt : 1}}));
                                    }}
                                >
                                    Activate
                                </SecondaryButton>
                            </div>
                        )} */}
                    </div>
                );
            },
        },
    ];
    const formik = useFormik({
        initialValues: {
            name: '',
        },
        validationSchema: Yup.object({
            name: Yup.string(),
        }),
        onSubmit: async (values) => {
            await dispatch(createFeature(values));
            formik.resetForm();
            dispatch(fetchFeatures({sort : { createdAt : 1}}));
        },
    });
    return (
        <PageWithCard heading="Features">
            <div className="flex flex-col gap-4">
                <form
                    className="flex flex-col gap-4"
                    onSubmit={formik.handleSubmit}
                >
                    <FormikInputGroup
                        label="Name"
                        formik={formik}
                        required
                        name={'name'}
                    />
                    <div>
                        <PrimaryButton
                            type="submit"
                            disabled={formik.isSubmitting}
                        >
                            Submit
                        </PrimaryButton>
                    </div>
                </form>
                <TableWithHeadingAndSearch
                    columns={cols}
                    data={features?.docs ? features?.docs : []}
                    heading={'Features'}
                />
            </div>
        </PageWithCard>
    );
};

export default Features;
